import IConsentConfigurationProps from '../types/IConsentConfigurationProps';

export default function getReplacementTokens(
    consentConfiguration?: IConsentConfigurationProps
  ) {
    const days: number =
      consentConfiguration && consentConfiguration.daysOfHistoricalTransactions
        ? consentConfiguration.daysOfHistoricalTransactions
        : 0;
  
    return { daysOfHistoricalTransactions: days };
  }